import React from 'react';
import Images from 'constants/images';
import { RiDatabaseLine } from 'react-icons/ri';
import { TbReport, TbClipboardData, TbReportMedical } from 'react-icons/tb';
import { FaUserPlus } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';

const useWorkingAreas = () => {
  const { t } = useTranslation();

  const roles = JSON.parse(localStorage.getItem('role') || '[]');
  const isAdmin = Array.isArray(roles) && roles.includes('Admin');

  const areas = [
    {
      key: '1',
      area: t('WORKING_AREAS.DATA_ENTRY'),
      imgSrc: Images.dataEntry,
      icon: <RiDatabaseLine />,
      href: '/data_entry',
      textOnTop: t('WORKING_AREAS.DATA_FOR_THE_REGISTER_OF_INFORMATION'),
      infoText: t('WORKING_AREAS.DATA_FOR_THE_REGISTER_OF_INFORMATION'),
    },
    {
      key: '2',
      area: t('WORKING_AREAS.DATA_FOR_REPORT_99'),
      imgSrc: Images.masterDataManagement,
      icon: <TbClipboardData />,
      href: '/data_management',
      textOnTop: t('WORKING_AREAS.DATA_FOR_THE_REGISTER_OF_INFORMATION'),
      infoText: t('WORKING_AREAS.DATA_FOR_THE_REGISTER_OF_INFORMATION'),
    },
    {
      key: '3',
      area: t('WORKING_AREAS.ALLOCATION'),
      imgSrc: Images.masterDataManagement,
      icon: <TbClipboardData />,
      href: '/allocation',
      textOnTop: t('WORKING_AREAS.ALLOCATION'),
      infoText: t('WORKING_AREAS.ALLOCATION'),
    },
    {
      key: '4',
      area: t('WORKING_AREAS.REFERENCE_DATA_AND_CLASSIFICATIONS'),
      imgSrc: Images.masterDataManagement,
      icon: <TbClipboardData />,
      href: '/article8/master_data',
      textOnTop: t('WORKING_AREAS.ICT_INVENTORIES_AND_ICT_RISK'),
      infoText: t('WORKING_AREAS.ICT_INVENTORIES_AND_ICT_RISK'),
    },
    {
      key: '5',
      area: t('WORKING_AREAS.ICT_RISK_EXPOSURE'),
      imgSrc: Images.masterDataManagement,
      icon: <TbClipboardData />,
      href: '/article8/risk_exposure_layout',
      textOnTop: t('WORKING_AREAS.ICT_INVENTORIES_AND_ICT_RISK'),
      infoText: t('WORKING_AREAS.ICT_INVENTORIES_AND_ICT_RISK'),
    },
    {
      key: '6',
      area: t('WORKING_AREAS.ICT_RISK_ROLES_RESPONSIBILITIES'),
      imgSrc: Images.masterDataManagement,
      icon: <TbClipboardData />,
      href: '/article8/ict_risk',
      textOnTop: t('WORKING_AREAS.ICT_INVENTORIES_AND_ICT_RISK'),
      infoText: t('WORKING_AREAS.ICT_INVENTORIES_AND_ICT_RISK'),
    },
    {
      key: '7',
      area: t('WORKING_AREAS.REGISTER_OF_INFORMATION_FOR_SUBMISSION'),
      imgSrc: Images.reporting,
      icon: <TbReport />,
      href: '/reporting',
      textOnTop: t('WORKING_AREAS.REPORTING'),
      infoText: t('WORKING_AREAS.ANALYSIS_REPORTS_AND_SUBMISSION_PACKAGES'),
    },
    {
      key: '8',
      area: t('WORKING_AREAS.ICT_AND_RISK_MANAGEMENT_OVERVIEW'),
      imgSrc: Images.additionalReports,
      icon: <TbReportMedical />,
      href: '/additional_reporting',
      textOnTop: t('WORKING_AREAS.ICT_AND_RISK_MANAGEMENT_OVERVIEW'),
      infoText: t('WORKING_AREAS.ANALYSIS_REPORTS_AND_SUBMISSION_PACKAGES'),
    },
    {
      key: '9',
      area: t('WORKING_AREAS.ICT_INVENTORY_OVERVIEW_REPORTS'),
      imgSrc: Images.additionalReports,
      icon: <TbReportMedical />,
      href: '/article_8_reporting',
      textOnTop: t('WORKING_AREAS.ICT_INVENTORY_OVERVIEW_REPORTS'),
      infoText: t('WORKING_AREAS.ANALYSIS_REPORTS_AND_SUBMISSION_PACKAGES'),
    },
    {
      key: '10',
      area: t('WORKING_AREAS.DEPENDENCIES'),
      imgSrc: Images.additionalReports,
      icon: <TbReportMedical />,
      href: '/dashboard',
      textOnTop: t('WORKING_AREAS.DASHBOARD'),
      infoText: t('WORKING_AREAS.DASHBOARD'),
    },
    ...(isAdmin
      ? [
          {
            key: '11',
            area: t('WORKING_AREAS.MANAGE_ACCESS'),
            imgSrc: Images.reporting,
            icon: <FaUserPlus />,
            href: '/user_access_rights',
            textOnTop: t('WORKING_AREAS.USER_ACCESS_RIGHTS_MANAGEMENT'),
            infoText: t('WORKING_AREAS.USER_ACCESS_RIGHTS_MANAGEMENT'),
          },
        ]
      : []),
  ];

  return areas;
};

export default useWorkingAreas;
